// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
export const AssetFragmentDoc = gql`
    fragment asset on Asset {
  __typename
  id
  url
}
    `;